import { useIntl } from 'react-intl'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  saveCampaignCallback
} from 'Pages/Campaign/recoil/callbacks/callbacks'
import { step3IsEnabledState } from 'Pages/Campaign/recoil/state/page'
import { useRecoilCallback, useRecoilValue } from 'recoil'

const Footer = () => {
  const intl = useIntl()
  const step3IsEnabled = useRecoilValue(step3IsEnabledState)

  const saveCampaign = useRecoilCallback(saveCampaignCallback, [])
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  const onClickBack = () => {
    changeWizardStep(2)
  }

  const onClickNext = () => {
    saveCampaign(4)
  }

  return (
    <Flex justifyContent='space-between'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        onClick={onClickBack}
        data-mu-test='campaign-wizard__step-3__back-button'
      >
        {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
      </Button>
      <FlexItem>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={onClickNext}
          disabled={!step3IsEnabled}
          data-mu-test='campaign-wizard__step-3__next-button'
        >
          {intl.formatMessage({ id: 'Load.Common.Next' })}
        </Button>
      </FlexItem>
    </Flex>
  )
}

export default Footer
